import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { MyobService }  from './myob.service';

angular.module('app-lite.myob', [])
  .service('myobApi', downgradeInjectable(MyobService));
